exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-d5cd6e0c] .no-padding-cell-warpper{padding:0}[data-v-d5cd6e0c] .no-padding-cell-warpper .cell{padding:0}.cell-item[data-v-d5cd6e0c]{min-height:0.23958rem;padding:0 0.05208rem;line-height:0.23958rem;word-break:break-all}[data-v-d5cd6e0c] .el-table--mini .cell-item{min-height:0.21875rem;line-height:0.21875rem}.cell-item+.cell-item[data-v-d5cd6e0c]{padding-bottom:0;border-top:0.00521rem solid #E8E8E8}\n", ""]);

// exports
